import { render, staticRenderFns } from "./CreateSubCompanyFormModal.vue?vue&type=template&id=305a7347&scoped=true&"
import script from "./CreateSubCompanyFormModal.vue?vue&type=script&lang=ts&setup=true&"
export * from "./CreateSubCompanyFormModal.vue?vue&type=script&lang=ts&setup=true&"
import style0 from "./CreateSubCompanyFormModal.vue?vue&type=style&index=0&id=305a7347&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "305a7347",
  null
  
)

export default component.exports